export default function Contact() {
    return (
        <div className="contact">
            Contact
        </div>
    )
}